class ProductLampshadesOption extends window.BAO.CustomElement() {
  static get requiredAttributes () {
    return ['data-title', 'data-variant-id']
  }

  static get requiredElements () {
    return ['display-text', 'image']
  }

  selectedAttribute = 'aria-selected'

  connectedCallback () {
    super.connectedCallback()

    /**
     * @type {ProductLampshades}
     */
    this.lampshades = this.closest('product-lampshades')
    if (!this.lampshades) {
      throw new Error(
        `${this.displayName} should always be a descendant of product-lampshades`,
      )
    }

    const optionExists = this.lampshades.options.some(
      (option) => option === this,
    )
    if (!optionExists) {
      this.lampshades.options.push(this)
    }

    /**
     * @type {SiteDrawer}
     */
    this.drawer = this.closest('dialog[is="site-drawer"]')

    if (this.getAttribute(this.selectedAttribute) === 'true') {
      this.lampshades.selections = [
        {
          option: this,
          quantity: 1,
        },
      ]
    }
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this, 'click', this.handleClick.bind(this))
  }

  /**
   * Handles the click event on a product option
   * @param {PointerEvent} event - The click event
   * @fires MadeToOrderEvents.OptionSelected
   */
  handleClick (event) {
    event.preventDefault()

    // Do nothing if it's disabled
    if (this.hasAttribute('disabled')) return

    const isAlreadySelected = this.lampshades.selections.some(
      (selected) => selected.option === this,
    )

    if (isAlreadySelected) {
      this.lampshades.selections = this.lampshades.selections.filter(
        (selected) => selected.option !== this,
      )
    } else {
      this.lampshades.selections = []
      this.lampshades.selections.push({
        option: this,
        quantity: 1,
      })
    }

    for (const option of this.lampshades.options) {
      const isSelected = this.lampshades.selections.some(
        (selected) => selected.option === option,
      )

      option.setAttribute(
        this.selectedAttribute,
        isSelected ? 'true' : 'false',
      )
    }

    this.dispatchEvent(
      new CustomEvent('OptionSelected', {
        bubbles: true,
        composed: true,
        detail: {
          selectedOption: this,
        },
      }),
    )

    if (this.lampshades.selections.length > 0) {
      this.drawer.drawers.close()
    }
  }

  /**
   * Gets the display text for this option
   *
   * @returns {string}
   */
  getDisplayText () {
    return this.els['display-text'].element.textContent.trim()
  }

  /**
   * Gets the images for this option
   *
   * @returns {{ main: HTMLImageElement }}
   */
  getImages () {
    return {
      main: this.els.image.element.querySelector('img'),
    }
  }

  get trigger () {
    const drawerKey = this.drawer.key
    const trigger = window.BAO.Utils.getElement(
      `product-lampshades-trigger[data-drawers-trigger="${drawerKey}"]`,
      {
        context: this.lampshades,
      },
    )
    if (!trigger) {
      throw new Error(`Could not find trigger for ${drawerKey}`)
    }

    return trigger
  }
}

if (!customElements.get('product-lampshades-option')) {
  customElements.define('product-lampshades-option', ProductLampshadesOption)
}
